var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":"carousel-popout","hide-header":"","hide-footer":"","centered":"","size":"xl","body-class":"p-0 bg-gray-1"}},[_c('carousel',{attrs:{"images":_vm.images},model:{value:(_vm.currentSlideIndexModel),callback:function ($$v) {_vm.currentSlideIndexModel=$$v},expression:"currentSlideIndexModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }